import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizePageSize } from './pageSize';
import { useAuth } from 'context/AuthContext';
import { useGlobal } from 'context/GlobalContext';
import { getStoredListPageSize } from './listPageSize';

export const useListOnPage = (storageKey?: string): number => {
    const { g } = useGlobal();
    const { auth } = useAuth();
    const location = useLocation();
    const key = storageKey ?? location.pathname;

    return useMemo(() => {
        if (!storageKey) {
            const fromPaginator = g?.paginator?.[location.pathname]?.onPage;
            if (fromPaginator) return normalizePageSize(fromPaginator);
        }
        return getStoredListPageSize(auth?.user?.ID, key);
    }, [auth?.user?.ID, g?.paginator?.[location.pathname]?.onPage, key, location.pathname, storageKey]);
};
